import { render, staticRenderFns } from "./precautions.vue?vue&type=template&id=18e595ca&scoped=true"
import script from "./precautions.vue?vue&type=script&lang=js"
export * from "./precautions.vue?vue&type=script&lang=js"
import style0 from "./precautions.vue?vue&type=style&index=0&id=18e595ca&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e595ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/dev-node-01/workspace/test-flight/tinggo/tinggo-vue-12765/server_app_code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18e595ca')) {
      api.createRecord('18e595ca', component.options)
    } else {
      api.reload('18e595ca', component.options)
    }
    module.hot.accept("./precautions.vue?vue&type=template&id=18e595ca&scoped=true", function () {
      api.rerender('18e595ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/precautions.vue"
export default component.exports